export default "__VITE_ASSET__a5133816__"